function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "#231F20"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 24C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12zm0-20.9c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9 8.9-4 8.9-8.9-4-8.9-8.9-8.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.2 11h-2.3V6.8c0-1-.8-1.9-1.9-1.9-1.1 0-1.9.8-1.9 1.9V11H7.8c-.7 0-1.1.8-.7 1.4l4.2 5.9c.4.5 1.1.5 1.4 0l4.2-5.9c.4-.6 0-1.4-.7-1.4z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;